import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=1a3541d2&scoped=true"
import script from "./advertising.vue?vue&type=script&lang=js"
export * from "./advertising.vue?vue&type=script&lang=js"
import style0 from "./advertising.vue?vue&type=style&index=0&id=1a3541d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3541d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3541d2')) {
      api.createRecord('1a3541d2', component.options)
    } else {
      api.reload('1a3541d2', component.options)
    }
    module.hot.accept("./advertising.vue?vue&type=template&id=1a3541d2&scoped=true", function () {
      api.rerender('1a3541d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/advertising.vue"
export default component.exports